/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Header_EndpointsInputs */

const en_platform_header_endpoints = /** @type {(inputs: Platform_Header_EndpointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endpoints`)
};

const zh_hans1_platform_header_endpoints = /** @type {(inputs: Platform_Header_EndpointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接口`)
};

const pt_br2_platform_header_endpoints = /** @type {(inputs: Platform_Header_EndpointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endpoints`)
};

const es_platform_header_endpoints = /** @type {(inputs: Platform_Header_EndpointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endpoints`)
};

const fr_platform_header_endpoints = /** @type {(inputs: Platform_Header_EndpointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endpoints`)
};

const de_platform_header_endpoints = /** @type {(inputs: Platform_Header_EndpointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endpoints`)
};

const ru_platform_header_endpoints = /** @type {(inputs: Platform_Header_EndpointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эндпоинты`)
};

const it_platform_header_endpoints = /** @type {(inputs: Platform_Header_EndpointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endpoint`)
};

/**
* | output |
* | --- |
* | "Endpoints" |
*
* @param {Platform_Header_EndpointsInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const platform_header_endpoints = /** @type {((inputs?: Platform_Header_EndpointsInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Header_EndpointsInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_platform_header_endpoints(inputs)
	if (locale === "pt-BR") return pt_br2_platform_header_endpoints(inputs)
	if (locale === "es") return es_platform_header_endpoints(inputs)
	if (locale === "fr") return fr_platform_header_endpoints(inputs)
	if (locale === "de") return de_platform_header_endpoints(inputs)
	if (locale === "ru") return ru_platform_header_endpoints(inputs)
	if (locale === "it") return it_platform_header_endpoints(inputs)
	return en_platform_header_endpoints(inputs)
});